import { useFlywire } from "./hooks/useFlywire";
import React, { useEffect } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import Text from "../../../../../../../../../shared/components/Text";
import { formatMoney } from "nemuru-components";

export const FlywireIframe = ({ paymentToken, paymentPlanLine }) => {
  const { flywire, getFlywireScriptEl } = useFlywire(
    paymentToken,
    paymentPlanLine.id
  );

  useEffect(() => {
    return () => {
      const flywireScriptEl = getFlywireScriptEl();
      if (!flywireScriptEl) return;
      document.body.removeChild(flywireScriptEl);
    };
  }, []);

  return (
    <Box
      flexGrow={1}
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"flex-end"}
    >
      <Box mt={2} mb={4}>
        <Typography variant={"body2"}>
          <Text
            tId={"FLYWIRE_PAYMENT_INSTALMENT_DETAIL"}
            dynamicDataTexts={[paymentPlanLine.quota_number + 1]}
          />
        </Typography>
      </Box>
      <Button
        variant={"contained"}
        color={"primary"}
        id={"flywire-btn"}
        disabled={!flywire}
      >
        <Text
          tId={"PAY_AMOUNT"}
          dynamicDataTexts={[formatMoney(paymentPlanLine.quota.amount, 2)]}
        />
      </Button>
    </Box>
  );
};
